import ReplyWithReplies from './';
import { ReplyWrap } from './Comment.styled';

export default function Replies({ replies }) {
  if (!replies?.length) return null;

  return (
    <ReplyWrap>
      {replies.map(reply => (
        <ReplyWithReplies {...reply} key={reply.id} />
      ))}
    </ReplyWrap>
  );
}
